module.exports = __webpack_public_path__ + "img/130016.79af57ea.png";